/* app/js/src/components/content-control/studio/content-control-studio/content-control-studio-timeline/content-control-studio-timeline-inclusive-segment/content-control-studio-timeline-inclusive-segment.component.scss */
:host {
  z-index: 2;
  top: 22px;
}
/*# sourceMappingURL=content-control-studio-timeline-inclusive-segment.component.css.map */
